import React from 'react';

export type BadgeVariant = 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info' | 'neutral';
export type BadgeSize = 'sm' | 'md' | 'lg';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  dot?: boolean;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'neutral',
  size = 'md',
  dot = false,
  className = '',
}) => {
  const variantClasses = {
    primary: 'bg-brand-50 dark:bg-brand-500/15 text-brand-700 dark:text-brand-300 border-transparent',
    secondary: 'bg-peach-100 dark:bg-peach-500/15 text-brand-700 dark:text-peach-300 border-transparent',
    success: 'bg-success-bg text-success border-transparent',
    warning: 'bg-warning-bg text-warning border-transparent',
    error: 'bg-brand-50 dark:bg-brand-500/15 text-brand-600 dark:text-brand-300 border-transparent',
    info: 'bg-info-bg text-info border-transparent',
    neutral: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-transparent',
  };

  const sizeClasses = {
    sm: 'h-[22px] px-2 text-xs',
    md: 'h-6 px-2.5 text-xs',
    lg: 'h-7 px-3 text-sm',
  };

  const dotColors = {
    primary: 'bg-brand-500',
    secondary: 'bg-peach-500',
    success: 'bg-success',
    warning: 'bg-warning',
    error: 'bg-brand-500',
    info: 'bg-info',
    neutral: 'bg-gray-400',
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 font-medium leading-none rounded-md border whitespace-nowrap
        ${variantClasses[variant]} ${sizeClasses[size]} ${className}
      `}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${dotColors[variant]}`}></span>}
      {children}
    </span>
  );
};

export default Badge;








